import { render } from "./Pricing.vue?vue&type=template&id=01e2b565&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=01e2b565&scoped=true&lang=css"

import exportComponent from "D:\\projectLinkoffer\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e2b565"]])

export default __exports__